import { render, staticRenderFns } from "./SocialMediaInfo.vue?vue&type=template&id=18309548&scoped=true&"
import script from "./SocialMediaInfo.vue?vue&type=script&lang=js&"
export * from "./SocialMediaInfo.vue?vue&type=script&lang=js&"
import style0 from "./SocialMediaInfo.vue?vue&type=style&index=0&id=18309548&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18309548",
  null
  
)

export default component.exports